import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from '@chakra-ui/react';

import Spinners from '../../../../components/Loading/SpinnerLoading';
import DepartmentHistoryViewList from '../../../../components/Department/DepartmentHistoryViewList';
import * as actions from '../../../../redux/actions';

export default function HistoryDepartmentDashboard() {
  // Variable Define
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const task = useSelector((state) => state.task);
  const department = useSelector((state) => state.department);

  // Get Selected Task Data
  useEffect(() => {
    dispatch(actions.departmentAll()).then(() => {
      dispatch(actions.taskAll()).then(() => {
        setIsLoading(true);
      });
    });
    return () => {};
  }, []);

  // UI Rendering
  if (isLoading) {
    return (
      <div>
        <h2 className="text-gray-800 text-xl font-semibold py-1">
          สถานะงานในแต่ละแผนก
        </h2>

        <div className="py-4 md:py-6">
          <Link to="/">
            <Button variant="outline">กลับ</Button>
          </Link>
        </div>
        <div className="p-4">
          <DepartmentHistoryViewList department={department} />
        </div>
      </div>
    );
  }
  return <Spinners />;
}
